//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BaseInput",
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Boolean, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    type: {
      type: String,
      default: "text"
    },
    maxLength: {
      type: [String, Number],
      default: ""
    },
    pattern: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleChange(event) {
      this.$emit("change", event);
    },
    handleFocusOut(event) {
      this.$emit("focusout", event);
    },
    handleInput(event) {
      this.$emit("input", event);
    }
  }
});